import { successCodeWith0Request } from './request'

export function getControlList() {
  return successCodeWith0Request.get('/fill/wjsurveyquestion/getQualityControlQuestion?type=3').then(res => {
    const list = res.data.data

    return list.map(item => {
      return Object.assign({}, item, { content: JSON.parse(item.content), issue: JSON.parse(item.issue) })
    })
  })
}

export function updateControlQuestion(question) {
  return successCodeWith0Request.put('/fill/wjsurveyquestion', question)
}

export function createControlQuestion(question) {
  return successCodeWith0Request.post('/fill/wjsurveyquestion', question)
}

export function deleteControlQuestion(id) {
  return successCodeWith0Request.delete(`/fill/wjsurveyquestion/${id}`)
}
